export default {
    'BSC': 'BNB',
    'ETH': 'ETH',
    'Polygon': 'MATIC',
    'Avalanche': 'AVA'
}